import * as React from 'react';
import {HTMLAttributes} from 'react';
import cx from 'classnames';

export const Wrapper: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={cx(
        'text-[14px] relative w-[400px] min-h-[80px] px-[15px] py-[30px] mt-[25px]',
        'rounded-[10px] border border-[#d5dadd] bg-white',
        'flex items-center justify-between',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const Info: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={cx(
        'flex items-center w-full cursor-pointer text-[#3e4348]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const AddButton: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={cx(
        'flex text-3xl text-[#3e4348] absolute bottom-0 left-1/2 z-[1] cursor-pointer',
        ' -translate-x-1/2 translate-y-1/2',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const PlusIcon: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={cx(
        'w-[32px] h-[32px] rounded-[50%] bg-[#3e4348] relative border-2 border-[#f1f1f2]',
        ' after:absolute after:h-[15px] after:w-[2px] after:top-[50%] after:left-[50%] after:-translate-x-1/2 after:-translate-y-1/2 after:bg-white after:rotate-90',
        'before:absolute before:h-[15px] before:w-[2px] before:top-[50%]  before:left-[50%] before:-translate-x-1/2 before:-translate-y-1/2 before:bg-white',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const Dot: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={cx(
        'absolute -top-[27px] left-1/2 w-2 h-2 rounded bg-[#3e4348] z-[2]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
